<template>
  <nav class="breadCrumbNav w-1/4">
    <router-link to="/" class="font-medium no-underline hover:underline">
      <div v-if="isAuthenticated">Dashboard</div>
      <div v-else>Home</div>
    </router-link>
    <a class="ml-2 mr-2">></a>
    <router-link :to="currentRoute.path" class="font-medium no-underline hover:underline">
      {{ articleTitle }}
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { isAuthenticated } from '@/lib/AuthenticatorPlugin'

// Composables
const route = useRoute()

const currentRoute = computed(() => route)

const articleTitle = computed((): string => {
  let title = currentRoute.value.path.replace(/_/g, ' ').replace(/\/content\//, '')
  title = title[0].toUpperCase() + title.substr(1)
  return title
})
</script>

<style scoped></style>
